import { z } from 'zod';
const validator = v => {
  if (v) {
    return true;
  }
  return false;
};
export default z.custom(validator);